import { useTranslation } from 'react-i18next'
import { TemplateUpdateParams } from '../../../../types'
import { UseFormReturn } from 'react-hook-form'
import TextInput from '../../../../ui/form/TextInput'
import VariableTextInput from '../../../../ui/form/VariableTextInput'

export const EmailForm = ({ form }: { form: UseFormReturn<TemplateUpdateParams, any> }) => {
    const { t } = useTranslation()
    return <>
        <VariableTextInput.Field form={form} name="data.from.name" label={t('from_name')} required />
        <TextInput.Field
            form={form}
            name="data.from.address"
            label={t('from_email')}
            type="email"
            required />
        <VariableTextInput.Field
            form={form}
            name="data.subject"
            label={t('subject')}
            multiline
            required />
        <VariableTextInput.Field
            form={form}
            name="data.preheader"
            label={t('preheader')}
            multiline />
        <TextInput.Field form={form} name="data.reply_to" label={t('reply_to')} />
        <TextInput.Field form={form} name="data.cc" label={t('cc')} />
        <TextInput.Field form={form} name="data.bcc" label={t('bcc')} />
    </>
}
